var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
function EditDateTimePicker(props) {
    var value = props.value, onChange = props.onChange;
    var handleChange = function (value) {
        var date = value;
        onChange(date);
    };
    return (React.createElement(DesktopDateTimePicker, { onChange: handleChange, inputFormat: "yyyy-MM-dd HH:mm", ampm: false, value: value, renderInput: function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { sx: {
                minWidth: 180,
            }, variant: "standard", margin: "none", fullWidth: true }))); } }));
}
export default EditDateTimePicker;
